export const styles = (theme) => ({
  root: {
    padding: '10px 15px',
    maxWidth: 1280,
    margin: '0 auto',
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  toolbar: {
    marginBottom: theme.spacing(3),
  },
  noResultsBlock: {
    padding: '1.72em 0 2em',
    opacity: 0.5,
    background: theme.palette.background.default,
  },
  loader: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.textColor.secondary,
  },
});
